module.exports = __webpack_public_path__ + "6f883fc020f02c40acfc47a1a63dd2c1.pdf";